import React from "react";
import {
  bgColor,
  colorLightGrey,
  primaryColor,
} from "../../../utility/constants/colorManager";

function CustomStepper({
  totalStep = 3,
  containerStyle,
  currentStep = 1,
  style,
}) {
  const stepperData = Array.from(Array(totalStep).keys());

  return (
    <div
      style={{
        width: "100%",
        marginTop: 10,
      }}
    >
      <p
        style={{
          padding: 0,
          margin: 0,
          fontSize: 14,
          fontWeight: "500",
          marginLeft: 10,
          marginBottom: 5,
        }}
      >
        Step {`0${currentStep}/0${totalStep}`}
      </p>

      <div
        style={{
          width: "90%",
          height: 3,
          margin: "0px 10px",
          backgroundColor: colorLightGrey,
          ...style,
        }}
      >
        <div
          style={{
            width:
              totalStep === currentStep
                ? "100%"
                : `${(100 / totalStep) * currentStep}%`,
            height: "100%",
            backgroundColor: primaryColor,
            transition: "width 0.5s ease-in",
          }}
        ></div>
      </div>
    </div>
  );
}

export default CustomStepper;
